module.exports = __webpack_public_path__ + "img/ts-logo.25b38abb.svg";